import { h } from '@stencil/core';

const Icon = ({ width = '100%', height = '100%' }) => {
  return (
    <svg width={width} height={height} version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 512 512" enable-background="new 0 0 512 512">
      <g>
        <line
          fill="none"
          stroke="#131313"
          stroke-width="13"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          x1="149.159"
          y1="174.509"
          x2="238.787"
          y2="174.509"
        />

        <line
          fill="none"
          stroke="#131313"
          stroke-width="13"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          x1="195.092"
          y1="223.914"
          x2="195.092"
          y2="175.47"
        />
        <path
          fill="none"
          stroke="#131313"
          stroke-width="13"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          d="
     M150.056,225.838h93.032v19.287c0,0,41.978,0,57.861,0s54.458-21.556,78.283-36.305c23.825-14.749,56.727-11.345,82.821,20.422
     l-29.498,31.767c0,0-26.094-32.901-52.188-5.673s-83.955,83.955-83.955,83.955H104.675c0,0-12.48,0-12.48-23.825s0-51.054,0-51.054
     L150.056,225.838z"
        />
        <path
          fill="none"
          stroke="#131313"
          stroke-width="13"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          d="
     M120.916,240.207c0,0-47.959-95.952-92.704-46.446c-38.648,42.761,32.072,75.92,66.937,69.206"
        />
        <path
          fill="none"
          stroke="#131313"
          stroke-width="13"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          d="
     M470.862,329.894c-10.751,0-19.498-8.747-19.498-19.498c0-5.929,2.608-17.179,7.595-27.21c5.031-10.122,9.972-13.895,11.903-13.895
     s6.872,3.772,11.903,13.895c4.986,10.031,7.595,21.281,7.595,27.21C490.36,321.146,481.613,329.894,470.862,329.894z"
        />
      </g>
    </svg>
  );
};

export default Icon;
